
import { useStore } from "../../state/state.ts";
import Measure from "../measure.tsx";
import ModalHeizung from "../../modals/modal_heizung.tsx";
import ModalHeizungFuture from "../../modals/modal_heizung_future.tsx";
import { MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT_LABELS, MASSNAHMEN_HEIZUNG_OPTIONS_NEW_LABELS } from "../../state/types.ts";

export default function MeasureWidgetHeizung() {
  const heizung = useStore((state)=>state.heizung || "");
  const heizung_future = useStore((state)=>state.heizung_future || "");

  const push_modal = useStore((state) => state.push_modal_closeable);
  const is_step_id = useStore((state) => state.is_step_id);
  const measure_lables = useStore((state)=>state.measure_lables);

  if (heizung == "" && heizung_future == ""){
    return <></>;
  }

    const current = measure_lables[heizung] || MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT_LABELS[heizung] || "" ;
    const future = measure_lables[heizung_future] || MASSNAHMEN_HEIZUNG_OPTIONS_NEW_LABELS[heizung_future] || "" ;
    
  return <Measure key={"measure-widget-heizung"} label={"Heizung"} now={current} future={future} onClick={() => push_modal(is_step_id("future")?<ModalHeizungFuture/>:<ModalHeizung/>)}/>;
}
